/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InfoMessageList } from './InfoMessageList';
import {
    InfoMessageListFromJSON,
    InfoMessageListFromJSONTyped,
    InfoMessageListToJSON,
    InfoMessageListToJSONTyped,
} from './InfoMessageList';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseInfoMessage
 */
export interface ResponseInfoMessage {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseInfoMessage
     */
    result: ResponseResult;
    /**
     * 
     * @type {InfoMessageList}
     * @memberof ResponseInfoMessage
     */
    data: InfoMessageList;
}

/**
 * Check if a given object implements the ResponseInfoMessage interface.
 */
export function instanceOfResponseInfoMessage(value: object): value is ResponseInfoMessage {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseInfoMessageFromJSON(json: any): ResponseInfoMessage {
    return ResponseInfoMessageFromJSONTyped(json, false);
}

export function ResponseInfoMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseInfoMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': InfoMessageListFromJSON(json['data']),
    };
}

export function ResponseInfoMessageToJSON(json: any): ResponseInfoMessage {
    return ResponseInfoMessageToJSONTyped(json, false);
}

export function ResponseInfoMessageToJSONTyped(value?: ResponseInfoMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': InfoMessageListToJSON(value['data']),
    };
}

